// extracted by mini-css-extract-plugin
export default {"box":"ICUuntF03AyHKJXcYl4v","contentBox":"d0lmpPn6uXWsizXs4Pd9","titleBox":"G8nOIw1GkqTTnEZyujYE","infoBox":"uujadpSKAOBjExDsMo2u","description":"ujNe1qNQkFpi8si7rK8I"};